export const units = {
  desktop: {sidePadding: '1.333rem'},
  tablet: {sidePadding: '2rem'},
  mobile: {sidePadding: '1.25rem'},
  mobileSm: {sidePadding: '1rem'},
  mobileXs: {sidePadding: '.5rem'},
};
